<template>
  <div class="no-loading">
    <van-loading  vertical size="24" >{{title}}</van-loading>
  </div>
</template>

<script>
export default{
  	props:{
      title:{
        type:String,
        default:'加载中'
      }
    },
  }
</script>

<style lang="less" scoped>
  .no-loading{text-align: center;margin: 80% 0;}
</style>



// WEBPACK FOOTER //
// src/components/common/loading.vue